import { ViewMode } from '@40seas/entities/common';
import { WrongToken, WrongUrl } from '@40seas/payments-shared';
import { Box } from '@mui/material';
import { FullScreenErrorPage } from '../../components/admin/errors/FullScreenErrorPage';
import { LayoutStrategyProvider, LayoutStrategyProviderParams } from './layoutStrategyProvider';
import { isGuestRole } from '@40seas/frontend/libs/hooks';

export class RedirectStrategyProvider implements LayoutStrategyProvider {
    constructor(private readonly params: LayoutStrategyProviderParams) {}

    shouldApply = (): boolean => {
        const { appStore, user } = this.params;

        if (user?.role && isGuestRole(user?.role)) {
            return false;
        }

        return (
            window.location.pathname !== '/' &&
            !decodeURI(window.location.pathname).toLowerCase().startsWith(`${appStore.basename.toLowerCase()}`)
        );
    };

    showLayout = () => {
        const { urlToken, appStore, user } = this.params;

        if (['/signup', '/login'].includes(window.location.pathname)) {
            window.location.href = (window as any).__SETUP__.urls.DASHBOARD_URL;
            return;
        }

        return (
            <Box height="100dvh">
                <FullScreenErrorPage>
                    {urlToken && appStore.viewMode === ViewMode.Supplier ? (
                        <WrongToken email={user?.email} />
                    ) : (
                        <WrongUrl email={user?.email} />
                    )}
                </FullScreenErrorPage>
            </Box>
        );
    };
}
